import React from 'react';
import ReactDOM from 'react-dom';
import { BootcampApp } from './BootcampApp';

ReactDOM.render(
    <BootcampApp />,
  document.getElementById('root')
);
